import script from "./TagChips.vue?vue&type=script&setup=true&lang=js"
export * from "./TagChips.vue?vue&type=script&setup=true&lang=js"

import "./TagChips.vue?vue&type=style&index=0&id=bd47ed02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd47ed02"]])

export default __exports__